import { fg } from '@atlassian/jira-feature-gating';

const AutonomousAgentsInSpaceRelayProvider = {
	get(): boolean {
		return fg('autonomous_agents_in_space');
	},
};

export default AutonomousAgentsInSpaceRelayProvider;
